
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexhvivVnuFe4mDPlC9TXo62Q3LLDyj1xgA63gY0m0t0iwMeta } from "/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/index.vue?macro=true";
import { default as liveQeKemcUN9S5wHSojlDVnsFBpaVrYKGCbzJSNeaV8x94Meta } from "/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/browse/live.vue?macro=true";
import { default as featuredvCkVcSnfeB5pj9FHs3Nl44YctwDkgLCk7qXPMGaXvsMMeta } from "/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/browse/featured.vue?macro=true";
import { default as _91id_938LVWnAd02kF56_45Z9pWQ01zG0f5fGRjuLZTpVFrfhU3IMeta } from "/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/browse/categories/[id].vue?macro=true";
import { default as indexSOEe_dq_ISqUKCYaai9nfN430mZAp2kQ6Fz2XKAvOykMeta } from "/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/browse/categories/index.vue?macro=true";
import { default as categoriesJJIuDxtf1krNRICIEDTIC9AbM74qL7GAz8g_45GgpQt7gMeta } from "/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/browse/categories.vue?macro=true";
import { default as browsemS2he0oR4eyqRPIB_45ud_45LyYizQ_45OBcFdQ69cJcFPVOwMeta } from "/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/browse.vue?macro=true";
import { default as streams_dJrj53OTyDCuSE_45BnloXl4tbWF6YugvsVj8EP3hCEUMeta } from "/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/search/streams.vue?macro=true";
import { default as channelsOGSLIMfCyS9zIN8cCWcz6hDZvpxwxFRpjrdWKMZd2EsMeta } from "/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/search/channels.vue?macro=true";
import { default as searchl3lDcmnoJS7ti7v8oVv3Co2smKgeHUBbZ67SVWWSDtAMeta } from "/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/search.vue?macro=true";
import { default as profile_45xwXKJ2yfd9QbsGEhwPhw6zkq8aQbvwDWqT7DqicY0QMeta } from "/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/settings/profile.vue?macro=true";
import { default as notificationsVnJCtzdJnbuvbiXTXCYTWtzmzV11Iz1awi1t7Q6MeIYMeta } from "/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/settings/notifications.vue?macro=true";
import { default as settings6KvXoyeDh_M07ahNpHs00aESrktwxxrYPSugDbWl0aQMeta } from "/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/settings.vue?macro=true";
import { default as _91userName_93gs_45gCDt2CSP2Y463Gk06VYev58efMjaTzzdZUCMNqgcMeta } from "/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/[userName].vue?macro=true";
import { default as _91slug_93R48JM9oyU2W5UXIhQay7UUlEoqCpr0dIGQ1ml0_45zcEEMeta } from "/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/watch/[slug].vue?macro=true";
import { default as indexRnzm7_45ZzsuQo_4l1WOGdLOSADPX_TjQTf37zsYQMCCYMeta } from "/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index.vue?macro=true";
import { default as loginap1BJ0xiAa9aCmDl_45XwSOzx_45H9wcLrTs3HLDCB0iFqEMeta } from "/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/login.vue?macro=true";
import { default as empty_45CS6PMu1_45gBYXD14C5_3ZGfQz9GTYDHcSkh_45Vc2P8QAMeta } from "/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/dashboard/empty.vue?macro=true";
import { default as indexmowOOirz1AzOnYS8akpYrtRqFhtp4bMCx1ulRsurdUYMeta } from "/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/dashboard/index.vue?macro=true";
import { default as streampcqusKpI13zOIj3X_458PbNSa6ABiG1EP_45ILzuWzCLDrIMeta } from "/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/dashboard/stream.vue?macro=true";
import { default as stream_45managerlExfQFg7qhNDcWTEC2K6O5aZWl3CCcYOUxPJHq7EjX0Meta } from "/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/dashboard/stream-manager.vue?macro=true";
import { default as streamarBM4R5Eav6C_457YZ4oDASzHo3SYsvAxqS418aqBeQrEMeta } from "/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/dashboard/settings/stream.vue?macro=true";
import { default as moderationWB1GaGU3iIkOTib5p_PVKmeATN1ZqcpDcOqdqjBqdLkMeta } from "/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/dashboard/settings/moderation.vue?macro=true";
import { default as past_45streamsIl6xoRj2uIZ5WDrNAtO04ETv4blylZ3y5RFMshhctTsMeta } from "/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/dashboard/settings/past-streams.vue?macro=true";
import { default as dashboardZqXoppbRWaa_45wvZ0NLBH1MVIFke5e9HvJ_srBc3evYYMeta } from "/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/dashboard.vue?macro=true";
export default [
  {
    name: indexRnzm7_45ZzsuQo_4l1WOGdLOSADPX_TjQTf37zsYQMCCYMeta?.name,
    path: "/",
    component: () => import("/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index.vue"),
    children: [
  {
    name: "index___en",
    path: "",
    component: () => import("/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/index.vue")
  },
  {
    name: "index-browse___en",
    path: "browse",
    meta: browsemS2he0oR4eyqRPIB_45ud_45LyYizQ_45OBcFdQ69cJcFPVOwMeta || {},
    component: () => import("/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/browse.vue"),
    children: [
  {
    name: "index-browse-live___en",
    path: "live",
    component: () => import("/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/browse/live.vue")
  },
  {
    name: "index-browse-featured___en",
    path: "featured",
    component: () => import("/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/browse/featured.vue")
  },
  {
    name: categoriesJJIuDxtf1krNRICIEDTIC9AbM74qL7GAz8g_45GgpQt7gMeta?.name,
    path: "categories",
    component: () => import("/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/browse/categories.vue"),
    children: [
  {
    name: "index-browse-categories-id___en",
    path: ":id()",
    component: () => import("/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/browse/categories/[id].vue")
  },
  {
    name: "index-browse-categories___en",
    path: "",
    component: () => import("/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/browse/categories/index.vue")
  }
]
  }
]
  },
  {
    name: "index-search___en",
    path: "search",
    meta: searchl3lDcmnoJS7ti7v8oVv3Co2smKgeHUBbZ67SVWWSDtAMeta || {},
    component: () => import("/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/search.vue"),
    children: [
  {
    name: "index-search-streams___en",
    path: "streams",
    component: () => import("/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/search/streams.vue")
  },
  {
    name: "index-search-channels___en",
    path: "channels",
    component: () => import("/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/search/channels.vue")
  }
]
  },
  {
    name: "index-settings___en",
    path: "settings",
    meta: settings6KvXoyeDh_M07ahNpHs00aESrktwxxrYPSugDbWl0aQMeta || {},
    component: () => import("/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/settings.vue"),
    children: [
  {
    name: "index-settings-profile___en",
    path: "profile",
    component: () => import("/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/settings/profile.vue")
  },
  {
    name: "index-settings-notifications___en",
    path: "notifications",
    component: () => import("/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/settings/notifications.vue")
  }
]
  },
  {
    name: "index-userName___en",
    path: ":userName()",
    meta: _91userName_93gs_45gCDt2CSP2Y463Gk06VYev58efMjaTzzdZUCMNqgcMeta || {},
    component: () => import("/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/[userName].vue")
  },
  {
    name: "index-watch-slug___en",
    path: "watch/:slug()",
    component: () => import("/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/index/watch/[slug].vue")
  }
]
  },
  {
    name: "login___en",
    path: "/login",
    meta: loginap1BJ0xiAa9aCmDl_45XwSOzx_45H9wcLrTs3HLDCB0iFqEMeta || {},
    component: () => import("/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/login.vue")
  },
  {
    name: dashboardZqXoppbRWaa_45wvZ0NLBH1MVIFke5e9HvJ_srBc3evYYMeta?.name,
    path: "/dashboard",
    meta: { ...(dashboardZqXoppbRWaa_45wvZ0NLBH1MVIFke5e9HvJ_srBc3evYYMeta || {}), ...{"middleware":"dashboard-auth"} },
    component: () => import("/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/dashboard.vue"),
    children: [
  {
    name: "dashboard-empty___en",
    path: "empty",
    meta: empty_45CS6PMu1_45gBYXD14C5_3ZGfQz9GTYDHcSkh_45Vc2P8QAMeta || {},
    component: () => import("/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/dashboard/empty.vue")
  },
  {
    name: "dashboard___en",
    path: "",
    meta: indexmowOOirz1AzOnYS8akpYrtRqFhtp4bMCx1ulRsurdUYMeta || {},
    component: () => import("/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/dashboard/index.vue")
  },
  {
    name: "dashboard-stream___en",
    path: "stream",
    component: () => import("/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/dashboard/stream.vue")
  },
  {
    name: "dashboard-stream-manager___en",
    path: "stream-manager",
    meta: {"middleware":"mobile-redirect"},
    component: () => import("/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/dashboard/stream-manager.vue")
  },
  {
    name: "dashboard-settings-stream___en",
    path: "settings/stream",
    component: () => import("/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/dashboard/settings/stream.vue")
  },
  {
    name: "dashboard-settings-moderation___en",
    path: "settings/moderation",
    meta: moderationWB1GaGU3iIkOTib5p_PVKmeATN1ZqcpDcOqdqjBqdLkMeta || {},
    component: () => import("/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/dashboard/settings/moderation.vue")
  },
  {
    name: "dashboard-settings-past-streams___en",
    path: "settings/past-streams",
    component: () => import("/home/runner/work/hmclive-viewer/hmclive-viewer/src/pages/dashboard/settings/past-streams.vue")
  }
]
  }
]